import { word } from "@modules/core/utils/i18n"
import { ChronoBloc } from "@modules/sessionBlock/exercises/components/chronoBloc"
import { ExerciseDraftForm } from "@modules/sessionBlock/exercises/components/exerciseDraftForm"
import { RpeBloc } from "@modules/sessionBlock/exercises/components/rpeBloc"
import { ScoreBloc } from "@modules/sessionBlock/exercises/components/scoreBloc"
import { ExerciseFormikType } from "@modules/sessionBlock/exercises/exerciseFormikTypes"
import { useSessionFormContext } from "@modules/sessions/hooks/useSessionFormContext"
import { useSessionSidebar } from "@modules/sessions/hooks/useSessionSidebar"
import { HUButton } from "@modules/ui/components/huButton"
import { useMemo } from "react"

export const ExerciseFormInfos: React.FC = () => {
  const { sidebarNavigateBack } = useSessionSidebar()
  const { formik, setInitialUpdatedBlock, updatedBlockIndex } = useSessionFormContext()

  const currentExercise = useMemo(() => {
    return updatedBlockIndex !== null && (formik.values.blocks[updatedBlockIndex]?.content as ExerciseFormikType)
  }, [updatedBlockIndex, formik])

  return (
    <div className="flex flex-column gap-2 pb-4">
      {currentExercise && updatedBlockIndex !== null && (
        <div className="flex flex-column gap-5">
          <ExerciseDraftForm />
          <RpeBloc />
          <ScoreBloc />
          <ChronoBloc />
        </div>
      )}

      <div className="pt-3 flex flex-row align-items-center justify-content-between">
        <HUButton
          type="Default"
          colorType="Primary"
          size="L"
          text={word("global.check")}
          className="p-button-primary w-full"
          onClick={async () => {
            formik.values.blocks.map((_, index) => {
              formik.setFieldTouched(`blocks[${index}].content.otherCategory`)
              formik.setFieldTouched(`blocks[${index}].content.description`)
            })
            if (formik.validateField) {
              await formik.validateField("blocks")
              if ((formik.errors && !formik.errors.hasOwnProperty("blocks")) || !formik.errors) {
                setInitialUpdatedBlock(undefined)
                sidebarNavigateBack(false)
              }
            }
          }}
        />
      </div>
    </div>
  )
}
